(function () {
  class SplashScreen extends PIXI.Container {
    constructor() {
      super();

      this.currentPageIndex = 0;
    }

    //////////////////////////////////////////////////
    initialise() {
      messageBus.subscribe('spinner:GameConfigEvent', () => {
        this.onLayoutComplete();
      });
      messageBus.subscribe('game:onCloseTutorial', () => {
        this.onCloseTutorial();
      });
      messageBus.subscribe('game:goToSplash', () => {
        this.onGoToSplash();
      });
    }

    //////////////////////////////////////////////////
    onLayoutComplete() {
      this.grabSplashScreenComponents();
      this.initSplashScreenArrowButtons();
    }

    onGoToSplash() {
      const splashScreenBackgroundLandscape = resourceManager.get(this.name + ':splashBackgroundL');
      splashScreenBackgroundLandscape.setInteractiveCallbacks(gdk.loadingClosed, true);
      const splashScreenBackgroundPortrait = resourceManager.get(this.name + ':splashBackgroundP');
      splashScreenBackgroundPortrait.setInteractiveCallbacks(gdk.loadingClosed, true);
      resourceManager.getContainer('splashContainer').visible = true;

      this.showCurrentSplashScreenPanel();

      this.swapPanelTimeline = gsap.timeline({ repeat: -1 }).call(
        () => {
          this.changePage(1);
        },
        undefined,
        '<+=5'
      );

      gameData.inputOverlord.setState('disabled');

      Utils.autoClickForReplayRewatch(gdk.loadingClosed);
    }

    onCloseTutorial() {
      Utils.stopAutoClickForReplayRewatch();
      resourceManager.getContainer('splashContainer').visible = false;
      const splashScreenBackgroundLandscape = resourceManager.get(this.name + ':splashBackgroundL');
      splashScreenBackgroundLandscape.clearInteractiveCallbacks();
      const splashScreenBackgroundPortrait = resourceManager.get(this.name + ':splashBackgroundP');
      splashScreenBackgroundPortrait.clearInteractiveCallbacks();
      if (this.swapPanelTimeline) {
        this.swapPanelTimeline.pause();
      }
      this.disableSplashScreenArrowButtons();
    }

    grabSplashScreenComponents() {
      this.pages = [];
      for (let i = 0; i < 5; i++) {
        const page = resourceManager.get(this.name + `:pagesContainer:page${i}`);
        if (page) {
          this.pages.push(page);
        }
      }

      this.arrowLeft = resourceManager.get(this.name + ':arrowContainer:arrowLeft');
      this.arrowRight = resourceManager.get(this.name + ':arrowContainer:arrowRight');

      // const leftPolygon = [50, -140, 10, -140, -48, 0, 10, 140, 50, 140];
      // this.arrowLeft.hitArea = new PIXI.Polygon(leftPolygon);
      // const rightPolygon = [-50, -140, -10, -140, 48, 0, -10, 140, -50, 140];
      // this.arrowRight.hitArea = new PIXI.Polygon(rightPolygon);

      // if (Reflex.developerModeData.showButtonHitAreas) {
      //   this.arrowLeft.graphics = new PIXI.Graphics();
      //   this.arrowLeft.graphics.beginFill(0x0000ff);
      //   this.arrowLeft.graphics.lineStyle(4, 0x0000ff, 1);
      //   this.arrowLeft.graphics.drawPolygon(leftPolygon);
      //   this.arrowLeft.graphics.endFill();
      //   this.arrowLeft.graphics.alpha = 0.5;
      //   this.arrowLeft.addChild(this.arrowLeft.graphics);
      // }

      // if (Reflex.developerModeData.showButtonHitAreas) {
      //   this.arrowRight.graphics = new PIXI.Graphics();
      //   this.arrowRight.graphics.beginFill(0x0000ff);
      //   this.arrowRight.graphics.lineStyle(4, 0x0000ff, 1);
      //   this.arrowRight.graphics.drawPolygon(rightPolygon);
      //   this.arrowRight.graphics.endFill();
      //   this.arrowRight.graphics.alpha = 0.5;
      //   this.arrowRight.addChild(this.arrowRight.graphics);
      // }
    }

    async changePage(direction) {
      if (this.splashScreenPanelSwapping) {
        return;
      }

      // we dont disable these, otherwise you could click on the background
      // this.arrowLeft.interactive = false;
      // this.arrowRight.interactive = false;
      this.splashScreenPanelSwapping = true;

      if (direction === -1) {
        this.arrowLeft.alpha = 0.7;
      } else {
        this.arrowRight.alpha = 0.7;
      }

      // fade out current panel
      // and fade in new one

      const currentIndex = this.currentPageIndex;
      let nextIndex = this.currentPageIndex + direction;
      if (nextIndex < 0) {
        nextIndex = this.pages.length - 1;
      } else if (nextIndex > this.pages.length - 1) {
        nextIndex = 0;
      }

      this.pages[nextIndex].visible = true;
      this.pages[nextIndex].alpha = 0;

      await Promise.all([
        Utils.tweenFromToAsync(
          this.pages[currentIndex],
          {
            alpha: 1,
          },
          {
            alpha: 0,
            duration: 0.25,
          }
        ),
        Utils.tweenFromToAsync(
          this.pages[nextIndex],
          {
            alpha: 0,
          },
          {
            alpha: 1,
            duration: 0.25,
          }
        ),
      ]);

      this.pages[currentIndex].visible = false;
      this.pages[currentIndex].alpha = 0;

      this.arrowLeft.alpha = 1;
      this.arrowRight.alpha = 1;

      this.currentPageIndex = nextIndex;
      // this.arrowLeft.interactive = true;
      // this.arrowRight.interactive = true;
      this.splashScreenPanelSwapping = false;
    }

    showCurrentSplashScreenPanel() {
      for (let i = 0; i < this.pages.length; i++) {
        this.pages[i].visible = false;
        this.pages[i].alpha = 0;
      }

      this.pages[this.currentPageIndex].visible = true;
      this.pages[this.currentPageIndex].alpha = 1;
    }

    disableSplashScreenArrowButtons() {
      this.arrowLeft.interactive = false;
      this.arrowRight.interactive = false;
    }

    leftArrowPressed() {
      this.changePage(-1);
      this.swapPanelTimeline.pause();
    }

    rightArrowPressed() {
      this.changePage(1);
      this.swapPanelTimeline.pause();
    }

    initSplashScreenArrowButtons() {
      this.arrowLeft.interactive = true;
      this.arrowRight.interactive = true;

      this.arrowLeft.on('mouseup', () => {
        this.leftArrowPressed();
      });
      this.arrowLeft.on('touchend', () => {
        this.leftArrowPressed();
      });

      this.arrowRight.on('mouseup', () => {
        this.rightArrowPressed();
      });
      this.arrowRight.on('touchend', () => {
        this.rightArrowPressed();
      });
    }
  }

  //////////////////////////////////////////////////
  create = function (json) {
    return new SplashScreen();
  };

  //////////////////////////////////////////////////
  initialise = function (json, container, resources) {
    container.initialise();
  };

  //////////////////////////////////////////////////
  getFilesRequired = function (json) {
    return ['', ''];
  };

  resourceManager.registerObjectType('SplashScreen', create, initialise, getFilesRequired);
})();
